/**
 *  Filename ....: servicesummary.component.ts
 *  Created by ..: ianday
 *  on Date .....: 10/9/23
 **/
import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-servicesummary',
    templateUrl: './servicesummary.component.html',
    styleUrls: ['./servicesummary.component.css']
})

export class ServiceSummaryComponent implements OnInit {

    constructor() {

    }

    ngOnInit() {

    }
}


